<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small" >
          <el-form-item label="子公司" prop="subcompanyIdList">
            <el-select multiple  v-model="dataForm.subcompanyIdList" @change="getSupCompanyList" class="input-width">
              <el-option
                  v-for="item in supCompanyList"
                  :key="item.id"
                  :label="item.orgName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="合同编码:">
                <el-input size="small" v-model="dataForm.contractCode" placeholder="合同编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="合同名称:">
                <el-input size="small" v-model="dataForm.contractName" placeholder="合同名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="合同类型:">
                <el-select size="small" v-model="dataForm.contractType" placeholder="请选择类型" clearable @change="getDataList">
                    <el-option v-for="item in CONTRACT_TYPE_VALUE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="合同状态:">
                <el-select size="small" v-model="dataForm.contractStatus" placeholder="请选择状态" clearable @change="getDataList">
                    <el-option v-for="item in CONTRACT_STATUS_VALUE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <!-- <el-input size="small" v-model="dataForm.contractStatus" placeholder="合同状态" clearable @blur="getDataList"></el-input> -->
            </el-form-item>
            <el-form-item label="乙方名称:">
                <el-input size="small" v-model="dataForm.partybRepresentive" placeholder="乙方名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" plain v-if="isAuth('sourcing:contract:newbutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    导入订单
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="small" bProject style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" border :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="contractCode" header-align="center" align="left" label="合同编码:" width="150">
                </el-table-column>
                <el-table-column prop="contractName" header-align="center" align="left" label="合同名称" width="150">
                </el-table-column>
                <el-table-column prop="contractType" header-align="center" align="left" label="合同类型" width="150">
                    <template slot-scope="scope">
                        {{ getCONTRACT_TYPE_VALUE(scope.row.contractType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="contractStatus" header-align="center" align="center" label="合同状态" width="150">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.contractStatus)">
                            {{ getContactStatusByValue(scope.row.contractStatus) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="purchasePartya" header-align="center" align="left" label="采购方甲方" width="150">
                </el-table-column>
                <el-table-column prop="partyaRepresentive" header-align="center" align="left" label="甲方代表" width="150">
                </el-table-column>
                <el-table-column prop="partyaSignDate" header-align="center" align="right" label="甲方签订日期" :formatter="dateFormat" width="170">
                </el-table-column>
                <el-table-column prop="supplierPartyb" header-align="center" align="left" label="供应商乙方" width="150">
                </el-table-column>
                <el-table-column prop="partybRepresentive" header-align="center" align="left" label="乙方代表" width="150">
                </el-table-column>
                <el-table-column prop="partybSignDate" header-align="center" align="right" label="乙方签订日期" :formatter="dateFormat" width="170">
                </el-table-column>
                <!-- <el-table-column prop="partybCode" header-align="center" align="left" label="乙方编码" width="150">
                </el-table-column> -->
                <el-table-column prop="createTime" header-align="center" align="right" label="创建时间" :formatter="dateFormat" width="170">
                </el-table-column>
                <el-table-column header-align="center" align="left" label="操作" width="190" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    getContractList,
    removeContract
} from '@/controller/contract'
import AddOrUpdate from './contract-add-or-update'
import {
    CONTRACT_TYPE_VALUE,
    CONTRACT_STATUS_VALUE,
    getCONTRACT_TYPE_VALUE,
    getCONTRACT_STATUS_VALUE,
} from "@/utils/const";
import {supCompanyList} from "../../../../controller/sys";
import moment from 'moment'
// require('@/mock/mockContract');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                contractCode:'',
                contractName:'',
                contractType:'',
                contractStatus: '',
                partybRepresentive:'',
                subcompanyIdList:'',
            },
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            CONTRACT_TYPE_VALUE:CONTRACT_TYPE_VALUE,
            CONTRACT_STATUS_VALUE: CONTRACT_STATUS_VALUE,
            getContactStatusByValue: getCONTRACT_STATUS_VALUE,
            getCONTRACT_TYPE_VALUE: getCONTRACT_TYPE_VALUE,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            supCompanyList: [],

        }
    },
    components: {
        AddOrUpdate
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 280
            }
        }
    },
    activated() {
        this.getDataList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        // 合同状态
        agreementTypeFormat: function (value) {
            // var value = row[column.property]
            if (!value) {
                return ''
            }
            return getAGREEMENT_TYPE_VALUE(CONTRACT_STATUS_VALUE, value)
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.getSupCompanyList();
            getContractList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                ...this.dataForm,
                // 'contractCode': this.dataForm.contractCode,//合同编码
                // 'contractName': this.dataForm.contractName,//合同名称
                // 'contractStatus': this.dataForm.contractStatus,//合同状态
                // 'contractType': this.dataForm.contractType,//合同类型
                // 'partybRepresentive': this.dataForm.partybRepresentive//乙方名称
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
      //获取子公司列表
      getSupCompanyList(){
        supCompanyList().then(res=>{
          if(res && res.code == '00'){
            this.supCompanyList = res.body;
          }
        })
      },
        viewHandle(row) {
            console.log(row)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            console.log(row)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            console.log(id)
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeContract({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-primary"
                    break;
                case '2':
                    className = "text-danger"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        }
    }
}
</script>
